<template>
  <a-card
    style="
      border: none;
      border-radius: 12px;
      minheight: calc(100vh - 100px - 40px);
    "
    title="高级设置"
  >
    <br />
    <br />
    <a-spin tip="Loading..." :spinning="spinning">
      <a-row>
        <a-col>
          <FormItem label="黄码过期提醒" labelWidth="180px">
            <a-input
              size="large"
              style="width: 180px; text-align: center"
              placeholder="请输入天数"
              type="number"
              v-model="ruleForm.timeout"
            /><span> 天后</span>
            <br />
            <br />
            <a-icon type="info-circle" /> 设置后系统将在设置天数后进行提醒
          </FormItem>
        </a-col>
        <br />
        <br />
        <br />
        <a-col>
          <FormItem label="年龄范围设置" labelWidth="180px">
            <a-row type="flex">
              <a-col flex="50px">
                <div class="label_ label_1">绿码</div>
              </a-col>
              <a-col flex="auto">
                <a-input-group compact>
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.man1min"
                    type="number"
                    placeholder="最小值"
                    :min="1"
                  />
                  <a-input
                    style="width: 30px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="~"
                    disabled
                  />
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.man1max"
                    type="number"
                    placeholder="最大值"
                    :min="ruleForm.man1min + 1"
                    @blur="
                      () => {
                        ruleForm.man2min = ruleForm.man1max;
                      }
                    "
                  />

                  <a-input
                    style="width: 50px; background: #fafbff"
                    size="large"
                    placeholder="男"
                    disabled
                  />
                </a-input-group>
                <br />
                <a-input-group compact>
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.woman1min"
                    type="number"
                    placeholder="最小值"
                    :min="1"
                  />
                  <a-input
                    style="width: 30px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="~"
                    disabled
                  />
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.woman1max"
                    type="number"
                    placeholder="最大值"
                    :min="ruleForm.woman1min + 1"
                    @blur="
                      () => {
                        ruleForm.woman2min = ruleForm.woman1max;
                      }
                    "
                  />
                  <a-input
                    style="width: 50px; background: #fafbff"
                    size="large"
                    placeholder="女"
                    disabled
                  />
                </a-input-group>
              </a-col>
            </a-row>
            <br />
            <a-row type="flex">
              <a-col flex="50px">
                <div class="label_ label_2">黄码</div>
              </a-col>
              <a-col flex="auto">
                <a-input-group compact>
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.man2min"
                    type="number"
                    placeholder="最小值"
                    @blur="
                      () => {
                        ruleForm.man1max = ruleForm.man2min;
                        if (ruleForm.man2min > ruleForm.man2max)
                          ruleForm.man2max = '';
                      }
                    "
                  />
                  <a-input
                    style="width: 30px; border: 0; background: #fafbff"
                    size="large"
                    placeholder="~"
                    disabled
                  />
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.man2max"
                    type="number"
                    placeholder="最大值"
                    :min="ruleForm.man2min + 1"
                  />

                  <a-input
                    style="width: 50px; background: #fafbff"
                    size="large"
                    placeholder="男"
                    disabled
                  />
                </a-input-group>
                <br />
                <a-input-group compact>
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.woman2min"
                    type="number"
                    placeholder="最小值"
                    :min="ruleForm.woman1max"
                    @blur="
                      () => {
                        ruleForm.woman1max = ruleForm.woman2min;
                        if (ruleForm.woman2min > ruleForm.woman2max)
                          ruleForm.woman2max = '';
                      }
                    "
                  />
                  <a-input
                    style="width: 30px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="~"
                    disabled
                  />
                  <a-input-number
                    style="
                      width: 100px;
                      text-align: center;
                      border: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.woman2max"
                    type="number"
                    :min="ruleForm.woman2min + 1"
                    placeholder="最大值"
                  />
                  <a-input
                    style="width: 50px; background: #fafbff"
                    size="large"
                    placeholder="女"
                    disabled
                  />
                </a-input-group>
              </a-col>
            </a-row>
            <br />
            <a-row type="flex">
              <a-col flex="50px">
                <div class="label_ label_3">红码</div>
              </a-col>
              <a-col flex="auto">
                <a-input-group>
                  <a-input
                    style="width: 80px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="小于"
                    disabled
                  />
                  <a-input
                    style="
                      width: 100px;
                      text-align: center;
                      border-left: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.man1min"
                    placeholder="最小值"
                    disabled
                  />
                  <a-input
                    style="width: 40px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="或"
                    disabled
                  />
                  <a-input
                    style="width: 80px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="大于"
                    disabled
                  />
                  <a-input
                    style="
                      width: 100px;
                      text-align: center;
                      border-left: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.man2max"
                    placeholder="最大值"
                    disabled
                  />

                  <a-input
                    style="width: 50px; background: #fafbff"
                    size="large"
                    placeholder="男"
                    disabled
                  />
                </a-input-group>
                <br />
                <a-input-group>
                  <a-input
                    style="width: 80px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="小于"
                    disabled
                  />
                  <a-input
                    style="
                      width: 100px;
                      text-align: center;
                      border-left: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.woman1min"
                    placeholder="最小值"
                    disabled
                  />
                  <a-input
                    style="width: 40px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="或"
                    disabled
                  />
                  <a-input
                    style="width: 80px; border-left: 0; background: #fafbff"
                    size="large"
                    placeholder="大于"
                    disabled
                  />
                  <a-input
                    style="
                      width: 100px;
                      text-align: center;
                      border-left: 0;
                      background: #fafbff;
                    "
                    size="large"
                    v-model="ruleForm.woman2max"
                    placeholder="最大值"
                    disabled
                  />
                  <a-input
                    style="width: 50px; background: #fafbff"
                    size="large"
                    placeholder="女"
                    disabled
                  />
                </a-input-group>
              </a-col>
            </a-row>
          </FormItem>
        </a-col>
        <br />
        <br />
        <a-col>
          <div class="tool">
            <a-button size="large" @click="getDefault"> 取消 </a-button>
            <a-button type="primary" size="large" @click="confirm">
              保存信息
            </a-button>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </a-card>
</template>

<script>
import FormItem from "@/components/FormItem/index";
import { personRule, personRuleSet } from "@/request/person";
export default {
  components: { FormItem },
  created() {
    this.getDefault();
  },
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 6 },
      spinning: false,
      ruleForm: {
        project_id: "",
        timeout: "",
        man1min: "", //男绿小
        man1max: "", //男绿大
        man2min: "", //男黄小
        man2max: "", //男黄大
        woman1min: "", //女绿小
        woman1max: "", //女绿大
        woman2min: "", //女黄小
        woman2max: "", //女黄大
      },
      rules: {},
    };
  },
  methods: {
    //获取默认
    getDefault() {
      this.spinning = true;
      personRule()
        .then((res) => {
          console.log(res);
          this.ruleForm = res.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.spinning = false;
          }, 200);
        });
    },
    //保存
    confirm() {
      this.spinning = true;
      personRuleSet(this.ruleForm)
        .then((res) => {
          console.log(res);
          this.$message.success('保存成功')
        })
        .finally(() => (this.spinning = false));
    },
  },
};
</script>

<style scoped>
.label_ {
  line-height: 40px;
  text-align: center;
}
.label_1 {
  color: #4dcc66;
}
.label_2 {
  color: #f7ae41;
}
.label_3 {
  color: #ea1313;
}
.tool {
  padding-left: 180px;
}
</style>